/// <amd-module name="Build/ArtifactsView/Constants" />
export namespace Telemetry {
    export const Area = "Build";
    export const RunArtifacts = "Pipelines.RunArtifacts";  
}